import appConfig from '@/config';
import dayjs from 'dayjs';
import durationPlugin from 'dayjs/plugin/duration';
import saveAs from 'file-saver';
import Swal from 'sweetalert2';
import { parseStringToHTML, parseStringToPDF } from './parser';
dayjs.extend(durationPlugin);
export function randomString(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
export const wait = async (waitTimeMs) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(true);
        }, waitTimeMs);
    });
};
export const clickOutside = (node) => {
    const handleClick = (event) => {
        if (!node.contains(event.target)) {
            node.dispatchEvent(new CustomEvent('out-click'));
        }
    };
    const gridContainer = document.querySelector('.grid-container');
    if (!!gridContainer) {
        gridContainer.addEventListener('click', handleClick, true);
        return {
            destroy() {
                gridContainer.removeEventListener('click', handleClick, true);
            }
        };
    }
    return {
        destroy() { }
    };
};
const dummyParentElement = document.createElement('div');
dummyParentElement.id = 'dummy-parent-element-dynamic-text-scale';
Object.assign(dummyParentElement.style, {
    position: 'absolute',
    // top: '-9999999999999999999px',
    // left: '-99999999999999px',
    display: 'block',
    zIndex: '1000000000',
    pointerEvents: 'none'
});
const stylesToCopy = [
    'lineHeight',
    'tabSize',
    'whiteSpace',
    'textTransform',
    'fontFamily',
    'fontWeight',
    'textTransform',
    'letterSpacing'
];
document.body.append(dummyParentElement);
export const applyDynamicTextScaling = (element, dimensions, targetParent = false) => {
    const newDimensions = typeof dimensions === 'function' ? dimensions() : dimensions;
    const parentStyles = element.parentElement?.style;
    if (parentStyles) {
        stylesToCopy.forEach(style => {
            // @ts-ignore
            const value = parentStyles[style];
            if (value) {
                // @ts-ignore
                dummyParentElement.style[style] = value;
            }
        });
    }
    dummyParentElement.style.width = newDimensions.width + 'px';
    dummyParentElement.style.height = newDimensions.height + 'px';
    const clonedNode = element.cloneNode(true);
    clonedNode.style.display = 'block';
    // Upscale the node
    let fontSize = (newDimensions.width + newDimensions.height) / 3;
    dummyParentElement.innerHTML = '';
    dummyParentElement.appendChild(clonedNode);
    let count = 0;
    const maxRetryLimit = 80;
    let currentDifference;
    let spanOverflow = false;
    const end = () => {
        clonedNode.remove();
        element.style.fontSize = fontSize + 'px';
        element.style.lineHeight = fontSize + 'px';
    };
    const spanElementOverflowing = (node) => {
        let overflowDetected = false;
        spanOverflow = false;
        node.querySelectorAll('span').forEach(span => {
            if (span.clientWidth >= newDimensions.width - 10) {
                overflowDetected = true;
                spanOverflow = span.clientWidth - newDimensions.width;
            }
        });
        return overflowDetected;
    };
    const isOverflowing = () => {
        const checkDimensions = clonedNode.getBoundingClientRect();
        currentDifference = {
            x: checkDimensions.width - newDimensions.width,
            y: checkDimensions.height - newDimensions.height,
            average: 0
        };
        const horizontalBased = currentDifference.x > currentDifference.y;
        currentDifference.average = currentDifference.y;
        let spanOverflowing = spanElementOverflowing(clonedNode);
        const scanLength = clonedNode.querySelectorAll('span').length;
        if (spanOverflowing && scanLength == 1) {
            currentDifference.average = spanOverflow;
        }
        return currentDifference.average > 20 || spanOverflowing;
    };
    const dynamicTextScale = (element) => {
        clonedNode.style.fontSize = fontSize + 'px';
        clonedNode.style.lineHeight = fontSize + 'px';
        if (count > maxRetryLimit) {
            // console.warn('[Reached the end of max retries for dynamic text scale]');
            // console.warn('Reached max try on limit');
            return end();
        }
        if (!isOverflowing()) {
            // console.info('[no longer overflowing] at ' + count + ' retries', currentDifference, dimensions, cD, clonedNode);
            return end();
        }
        // This code adjusts the font size of the text based on the difference between the text's width and the width of the container
        // If the text is too small, the font size is decreased slightly. If the text is too big, the font size is decreased significantly.
        // The code is contained within an if statement that checks if the difference between the text's width and the width of the container is less than 100px
        // If the text is too small, the font size is decreased by a small amount. If the text is too big, the font size is decreased by a large amount.
        if (currentDifference.average < 100) {
            let differenceCalculation = fontSize * 0.01;
            if (differenceCalculation < 1)
                differenceCalculation = 0.5;
            fontSize = fontSize - differenceCalculation;
        }
        else if (currentDifference.average < 150) {
            fontSize = fontSize * 0.9;
        }
        else if (currentDifference.average < 300) {
            fontSize = fontSize * 0.8;
        }
        else if (currentDifference.average < 600) {
            fontSize = fontSize * 0.6;
        }
        else
            fontSize = fontSize * 0.5;
        count++;
        dynamicTextScale(element);
    };
    if (element)
        dynamicTextScale(element);
};
export const _applyDynamicTextScaling = (element, dimensions, defaultTextSize) => {
    dummyParentElement.style.width = dimensions?.width + 'px';
    dummyParentElement.style.height = dimensions?.height + 'px';
    if (defaultTextSize)
        element.style.fontSize = defaultTextSize + 'px';
    const clonedNode = element.cloneNode(true);
    clonedNode.style.display = 'block';
    clonedNode.style.visibility = 'visible';
    dummyParentElement.innerHTML = '';
    dummyParentElement.append(clonedNode);
    // element.style.display = 'block';
    // element.style.visibility = 'hidden';
    const isOverflowing = (target) => {
        const computedParentStyles = getComputedStyle(target);
        const elemHeight = target.getBoundingClientRect().height;
        const elemWidth = target.getBoundingClientRect().width;
        if (!elemHeight)
            return false;
        // const parentHeight = target.parentElement?.getBoundingClientRect()
        //   .height as number;
        // const computedParentHeight =
        //   parentHeight -
        //   (parseFloat(computedParentStyles.paddingTop) +
        //     parseFloat(computedParentStyles.paddingBottom));
        if (!dimensions)
            return false;
        return elemHeight > dimensions.height && elemWidth > dimensions.width;
    };
    const dynamicTextScale = (el, count = 0, fs = '0px') => {
        if (count > 20)
            return false;
        if (!isOverflowing(clonedNode)) {
            // element.style.visibility = 'visible';
            el.style.fontSize = fs;
            return false;
        }
        const fontSize = Number.parseInt(window.getComputedStyle(clonedNode).fontSize);
        if (!fontSize)
            return false;
        let newsize = fontSize * 0.9 + 'px';
        clonedNode.style.fontSize = newsize;
        count++;
        //@ts-ignore
        if (window.enableDebug) {
            setTimeout(() => {
                dynamicTextScale(el, count, newsize);
            }, 250);
        }
        else
            dynamicTextScale(el, count, newsize);
    };
    if (element) {
        dynamicTextScale(element);
    }
};
let timer = null;
export const debounce = (e, callback) => {
    if (!!timer) {
        clearTimeout(timer);
    }
    timer = setTimeout(() => {
        callback(e);
    }, 750);
};
export const sortIndexes = (array) => {
    return array.sort((a, b) => a.index - b.index);
};
export const filterUnique = (array) => {
    return array.filter((v, i, a) => a.indexOf(v) === i);
};
export const getRandomArbitrary = (min, max) => {
    return Math.random() * (max - min) + min;
};
export const extractStylesFromObject = (node) => {
    const styles = window.getComputedStyle(node);
    return Object.values(styles).reduce((css, propertyName) => `${css}${propertyName}:${styles.getPropertyValue(propertyName)};`);
};
export const copyStyles = (srcNode, destinationNode) => {
    let styles = extractStylesFromObject(srcNode);
    destinationNode.style.cssText = styles;
};
export function toTitleCase(text) {
    const result = text.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
}
export function loadUserImageUrl(image) {
    if (!window.uData)
        return image;
    var defaultImageUrl = '/wp-content/uploads/user-images/' + window.uData['id'] + window.uData['user_nicename'];
    if (window.serverUserFolderImage) {
        defaultImageUrl = defaultImageUrl + '-' + window.serverUserFolderImage;
    }
    if (image) {
        if (image.charAt(0) == '/') {
            return defaultImageUrl + image;
        }
        return defaultImageUrl + '/' + image;
    }
    return defaultImageUrl + '/';
}
export function toTime(duration) {
    try {
        const totalMs = duration * 1000;
        const result = new Date(totalMs).toISOString().slice(11, 19);
        return result;
    }
    catch (error) {
        return '00:00:00';
    }
}
export function computeTime(marker) {
    let returnValue = 0;
    if (marker.seconds) {
        returnValue = +Math.round(marker.seconds) * 1000;
    }
    if (marker.nanos) {
        returnValue += +Math.round(marker.nanos) / 1000000;
    }
    return returnValue;
}
export const formatDate = (date) => {
    if (!date) {
        return 'Jan 01, 1970'; // Default date
    }
    const _d = new Date(date);
    if (isNaN(_d.getTime())) {
        return 'Invalid Date'; // Handle invalid date input
    }
    const options = { month: 'short', day: '2-digit', year: 'numeric' };
    return _d.toLocaleDateString('en-US', options);
};
export const formatDateTime = (date) => {
    if (!date) {
        return '01/01/1970 12:00 am'; // Default date and time
    }
    const d = new Date(date);
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    const year = d.getFullYear().toString();
    const hours = d.getHours() % 12 || 12; // Convert to 12-hour format
    const minutes = d.getMinutes().toString().padStart(2, '0');
    const ampm = d.getHours() >= 12 ? 'pm' : 'am';
    return `${formatDate(date)} ${hours}:${minutes}${ampm}`;
};
export const getImage = (imgName) => {
    if (appConfig.isProd) {
        return `/custom-code/js/clipper/images/${imgName}`;
    }
    return `/images/${imgName}`;
};
export const isValidYoutubeUrl = (string) => {
    let url;
    try {
        url = new URL(string);
    }
    catch (_) {
        return false;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
        return false;
    }
    return url.hostname === 'www.youtube.com' || url.hostname === 'youtu.be';
};
export function toPascalCase(string) {
    return `${string}`
        .toLowerCase()
        .replace(new RegExp(/[-_]+/, 'g'), ' ')
        .replace(new RegExp(/[^\w\s]/, 'g'), '')
        .replace(new RegExp(/\s+(.)(\w*)/, 'g'), ($1, $2, $3) => `${$2.toUpperCase() + $3}`)
        .replace(new RegExp(/\w/), s => s.toUpperCase());
}
export const formatHours = (hours) => {
    const floored = Math.floor(hours);
    const remainder = hours - floored;
    const computedMinutes = Math.floor(60 * remainder);
    let returnString = '';
    if (hours > 0) {
        returnString = `${floored} ${floored > 1 ? 'hours' : 'hour'}`;
        if (computedMinutes > 0)
            returnString += ' and ';
    }
    if (computedMinutes > 0)
        returnString += `${computedMinutes} ${computedMinutes > 1 ? 'minutes' : 'minute'}`;
    return returnString;
};
export const convertToHoursMinutes = (decimalHours) => {
    if (decimalHours < 0) {
        return '0 hours and 0 minutes';
    }
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);
    return `${hours} hour${hours !== 1 ? 's' : ''} and ${minutes} minute${minutes !== 1 ? 's' : ''}`;
};
export const transcribeToWords = (transcription) => {
    const formatted = transcription
        .map((item) => {
        return item.word;
    })
        .join(' ');
    return formatted;
};
export const mobileAndTabletCheck = function () {
    const userAgentRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const checkUsingUserAgent = userAgentRegex.test(navigator.userAgent);
    const checkUsingScreenSize = screenWidth < 1024;
    const isMobile = checkUsingUserAgent || checkUsingScreenSize;
    if (isMobile)
        setTimeout(() => document.querySelector('supportpal-widget')?.classList.add('hidden'), 3000);
    else
        setTimeout(() => document.querySelector('supportpal-widget')?.classList.remove('hidden'), 3000);
    return isMobile;
};
export const isValidUrl = (urlString) => {
    const inputElement = document.createElement('input');
    inputElement.type = 'url';
    inputElement.value = urlString;
    const valid = inputElement.checkValidity();
    inputElement.remove();
    return valid;
};
export const isSafari = () => {
    const userAgentString = navigator.userAgent;
    const chromeAgent = userAgentString.indexOf('Chrome') > -1;
    const safariAgent = userAgentString.indexOf('Safari') > -1;
    return !chromeAgent && safariAgent;
};
export const createFileUploadDialog = (events) => {
    return new Promise((resolve, reject) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.onchange = () => {
            if (input.files)
                resolve(input.files);
            else if (!input.files)
                reject(null);
        };
        input.click();
    });
};
export function removePunctuation(inputString) {
    return inputString.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()?"'<>]/g, '');
}
export function downloadAsText(filename, textContent) {
    const blob = new Blob([textContent], { type: 'text/plain' });
    const dlLink = document.createElement('a');
    dlLink.href = URL.createObjectURL(blob);
    dlLink.download = filename + '.txt';
    document.body.appendChild(dlLink);
    dlLink.click();
    document.body.removeChild(dlLink);
}
export function cutSentenceFromArray(arr, start, end) {
    return arr
        .filter((item, index) => {
        if (index >= start && index < end) {
            return index;
        }
    })
        .map(item => item)
        .join(' ');
}
export function getSentenceSimilarity(words, selectedHook) {
    let matches = 0;
    words.forEach((word) => {
        if (selectedHook.includes(word)) {
            matches++;
        }
    });
    return Math.round((matches / selectedHook.length) * 100);
}
export function canAccess(user, feature) {
    let permissions = user.permissions;
    if ((permissions && permissions.includes(feature)) || user.isAdmin || user.hasFullAccess) {
        return true;
    }
    return false;
}
export function addEventListener(target, event, callback) {
    target.addEventListener(event, callback);
    return () => target.removeEventListener(event, callback);
}
export async function download(filename, text, type, extension = 'txt') {
    let content;
    let blob;
    let fileExtension = extension;
    switch (extension) {
        case 'html-txt':
            content = parseStringToHTML(text);
            blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
            fileExtension = 'txt';
            break;
        case 'html':
            content = parseStringToHTML(text);
            blob = new Blob([content], { type: 'text/html' });
            break;
        case 'txt':
            content = removeTags(text) || '';
            blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
            break;
        case 'pdf':
            blob = await parseStringToPDF(text);
            break;
        default:
            return;
    }
    saveAs(blob, `${filename}.${fileExtension}`);
    Swal.fire({
        position: 'bottom-end',
        icon: 'success',
        title: type ? `${type} Downloaded` : 'Content Downloaded',
        showConfirmButton: false,
        timer: 1500,
        toast: true
    });
}
export function removeTags(str) {
    if (str === null || str === '')
        return false;
    else
        str = str.toString();
    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, '');
}
export function formatDuration(duration) {
    const durationNum = typeof duration === 'string' ? parseFloat(duration) : duration;
    if (isNaN(durationNum) || durationNum <= 0)
        return '00:00:00';
    const dur = dayjs.duration(durationNum, 'seconds');
    const hours = String(Math.floor(dur.asHours())).padStart(2, '0');
    const minutes = String(dur.minutes()).padStart(2, '0');
    const seconds = String(dur.seconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
}
export function validateMusicFile(filename) {
    // Define allowed extensions
    const allowedExtensions = ['mp3', 'flac', 'wav'];
    if (filename != null) {
        // Extract the file extension
        const extension = filename.split('.').pop()?.toLowerCase();
        if (extension) {
            // Check if the extension is in the allowed list
            return allowedExtensions.includes(extension);
        }
    }
    return false;
}
export function validateUrl(url) {
    const youtubeUrlRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
    const facebookUrlRegex = /^https:\/\/(?:www|web)\.facebook\.com\/(?:[^\/]+\/videos\/\d+|watch\/?\?v=\d+|reel\/\d+)\/?$|^https:\/\/fb\.watch\/[A-Za-z0-9_-]+\/?$/; // Matches Facebook video URLs
    const vimeoUrlRegex = /^(https?:\/\/)?(www\.)?(vimeo\.com)\/.+$/;
    // Validate YouTube URL
    if (youtubeUrlRegex.test(url)) {
        // Handle live YouTube URLs
        if (url.includes('youtube.com/live/')) {
            url = extractLive(url);
            console.log(`Extracted live YouTube URL: ${url}`);
        }
        try {
            // Parse the URL to extract the video ID
            const urlObj = new URL(url);
            const videoId = urlObj.searchParams.get('v');
            if (videoId) {
                return `https://www.youtube.com/watch?v=${videoId}`;
            }
            // Handle shortened YouTube URLs (e.g., youtu.be/<videoId>)
            if (urlObj.hostname === 'youtu.be' && urlObj.pathname.length > 1) {
                return `https://www.youtube.com/watch?v=${urlObj.pathname.slice(1)}`;
            }
        }
        catch (error) {
            console.error(`Error parsing YouTube URL: ${error}`);
        }
    }
    // Validate Facebook Video URL
    if (facebookUrlRegex.test(url)) {
        // Replace 'web.facebook.com' with 'www.facebook.com'
        return url.replace('https://web.facebook.com', 'https://www.facebook.com');
    }
    // Validate Vimeo URL
    if (vimeoUrlRegex.test(url)) {
        try {
            const urlObj = new URL(url);
            const channel = urlObj.pathname.split('/')[1];
            const videoId = urlObj.pathname.split('/')[2];
            if (videoId) {
                return `https://vimeo.com/${channel}/${videoId}`;
            }
            if (channel) {
                return `https://vimeo.com/${channel}`;
            }
        }
        catch (error) {
            console.error(`Error parsing Vimeo URL: ${error}`);
        }
    }
    console.warn(`Invalid URL: ${url}`);
    return null; // Return null if no valid video URL is found
}
function extractLive(url) {
    const segments = url.split('/');
    if (segments && segments.length > 1) {
        const lastSegment = segments[segments.length - 1];
        if (lastSegment) {
            const finalStr = lastSegment.split('?');
            return 'https://www.youtube.com/watch?v=' + finalStr[0];
        }
    }
    return 'invalid';
}
